// noinspection JSUnusedGlobalSymbols

import * as Apollo from '@apollo/client';

import { gql } from '@apollo/client';
import type * as Types from '../../__generated__/types';

const defaultOptions = {} as const;
export type DeleteDivisionMutationVariables = Types.Exact<{
  deleteDivisionId: Types.Scalars['ID']['input'];
}>;

export type DeleteDivisionMutation = { __typename?: 'Mutation' } & Pick<Types.Mutation, 'deleteDivision'>;

export const DeleteDivisionDocument = /*#__PURE__*/ gql`
    mutation DeleteDivision($deleteDivisionId: ID!) {
  deleteDivision(id: $deleteDivisionId)
}
    `;
export type DeleteDivisionMutationFn = Apollo.MutationFunction<DeleteDivisionMutation, DeleteDivisionMutationVariables>;

/**
 * __useDeleteDivisionMutation__
 *
 * To run a mutation, you first call `useDeleteDivisionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDivisionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDivisionMutation, { data, loading, error }] = useDeleteDivisionMutation({
 *   variables: {
 *      deleteDivisionId: // value for 'deleteDivisionId'
 *   },
 * });
 */
export function useDeleteDivisionMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteDivisionMutation, DeleteDivisionMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteDivisionMutation, DeleteDivisionMutationVariables>(DeleteDivisionDocument, options);
}
export type DeleteDivisionMutationHookResult = ReturnType<typeof useDeleteDivisionMutation>;
export type DeleteDivisionMutationOptions = Apollo.BaseMutationOptions<
  DeleteDivisionMutation,
  DeleteDivisionMutationVariables
>;
